<template>
  <pf-grid gutter>
    <template v-for="(feature, key) of allFeatures" :key="key">
      <pf-grid-item
        v-if="product[key] || product[key] === 0"
        :span="key === 'descrizione' ? 12 : 4"
      >
          <component :is="feature.icon" /> <product-feature :feature="key" :product="product" show-label />
      </pf-grid-item>
    </template>
  </pf-grid>
</template>

<script lang="ts" setup>
import { type CatalogProduct } from '@/resources';
import ProductFeature, { getAllProductFeatures } from './product-feature.vue';

defineProps<{
  product: CatalogProduct;
}>();

const allFeatures = getAllProductFeatures();
</script>
